import { LOCALE_ID,ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HttpBackend, HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from '@infrastructure/interceptors/token/token.interceptor';
import { errorInterceptor } from '@infrastructure/interceptors/error/error.interceptor';
import { loaderInterceptor } from '@infrastructure/interceptors/loader/loader.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MessageService } from '@progress/kendo-angular-l10n';
import { MyMessageService } from '@infrastructure/service/kendo-translate/custom-messages.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { messageInterceptor } from '@infrastructure/interceptors/message/message.interceptor';
import { environmentInterceptor } from '@infrastructure/interceptors/enviroment/enviroment.interceptor';
import '@progress/kendo-angular-intl/locales/es/all';


export function HttpLoaderFactory(httpHandler: HttpBackend) : TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(httpHandler), './translate/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideAnimations(),
    provideHttpClient(withInterceptors([
      tokenInterceptor,
      errorInterceptor,
      loaderInterceptor,
      messageInterceptor,
      environmentInterceptor
    ])),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'es',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpBackend]
        }
      })
    ),
    {
      provide: MessageService,
      useClass: MyMessageService
    },     
    {
        provide: LOCALE_ID,
        useValue: "es-ES",
    },
  

  ]
};
